import React from "react";
import Icon from "../Icon/Icon";
import Typography from "../Typography/Typography";
import styles from "./Error.module.css";
import iconPathRegistry from "../Icon/config/iconPathRegistry";

interface Props {
    label: string;
    icon?: keyof typeof iconPathRegistry;
}

const Error = ({ label, icon = "warning" }: Props) => (
    <div className={styles.errorArea}>
        <Icon icon={icon} width="28" height="28" className="text-plum-500" />
        <Typography as="span" variant="meta" color="plum">
            {label}
        </Typography>
    </div>
);

export default Error;
